<template>
    <div class="cp-home-case">
        <div :style="{
            'background-image': 'url(' + data.bg + ')',
            'width': '100%',
            'height': '100vh',
            'background-size': 'cover'
        }"></div>
        <div class="cp-home-case-content">
            <div :class="[
              'cp-home-follow-ani-start',
              isRender ? 'cp-home-follow-ani-1' : ''
            ]">
              <div class="cp-home-case-title">{{ data.title }}</div>
              <div class="cp-home-case-text">{{ data.text }}</div>
            </div>
            <div :class="[
              'cp-home-follow-ani-start',
              isRender ? 'cp-home-follow-ani-2' : ''
            ]">
              <img
                class="cp-home-case-qrcode"
                :src="data.qrcode">
              <div v-for="(item, i) in data.tip" class="cp-home-case-tip">{{ item }}</div>
            </div>
            <div
              :class="[
                'cp-home-case-recode',
                'cp-home-follow-ani-start',
                isRender ? 'cp-home-follow-ani-3' : ''
              ]">
              <span
                v-for="(item, i) in data.recode"
                style="margin-right: .1rem; display: inline-block">{{ item }}</span>
            </div>
        </div>
    </div>
</template>

<script>
const {Swiper, SwiperSlide}  = require('vue-awesome-swiper');
import 'swiper/css/swiper.css'
export default {
    name: 'cp-case',
    components: {
      Swiper,
      SwiperSlide
    },
    computed: {
      swiper() {
        return this.$refs.swiper.$swiper;
      }
    },
    props: {
      isInView: {
        type: Boolean,
        default: false
      },
      data: {
          type: Object,
          default() {
              return {};
          }
      }
    },
    data() {
        return {
            swiperOption: {
              spaceBetween: 30,
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            current: 0,
            isRender: false
        }
    },
    watch: {
        isInView(v) {
            if (v) {
                this.play();
            }
            else {
                this.isRender = false;
            }
        }
    },
    mounted() {
    },
    methods: {
      play() {
          if (this.isInView) {
              setTimeout(() => {
                  this.isRender = true;
              }, 200);
          }
      }
    }
}
</script>

<style scoped>
.cp-home-case {
    position: relative;
}
.cp-home-case-content {
    position: absolute;
    top: .93rem;
    padding: 1.24rem 1.2rem 0 1.2rem;
    color: #fff;
    width: 100%;
    box-sizing: border-box;
    margin-top: .08rem;
    text-align: center;
}
.cp-home-case-content-left {
    display: flex;
    flex-direction:column;
    align-items: center;
    position: absolute;
    height: 100%;
    margin-top: 1.16rem;
}
.cp-home-case-title {
    font-size: .54rem;
    font-weight: bold;
}
.cp-home-case-text {
    font-size: .2rem;
    margin-top: .21rem;
}
.cp-home-case-tip {
    opacity: .6;
    font-size: .2rem;
    margin-bottom: .1rem;
}
.cp-home-case-qrcode {
    width: 2.78rem;
    height: 2.78rem;
    margin-top: .68rem;
    margin-bottom: .27rem;
}
.cp-home-case-recode {
    opacity: .6;
    font-size: .16rem;
    color: #d8d8d8;
    margin-top: 1.32rem;
}
.cp-home-follow-ani-start {
    transform: translateX(2.8rem);
    opacity: 0;
}
.cp-home-follow-ani-1 {
    transition: all .6s ease-out;
    transform: translateX(0);
    opacity: 1
}
.cp-home-follow-ani-2 {
    transition: all .5s ease-out .3s;
    transform: translateX(0);
    opacity: 1
}
.cp-home-follow-ani-3 {
    transition: all .5s ease-out .5s;
    transform: translateX(0);
    opacity: .6;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Follow.vue